var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiRegenerate = function SvgAiRegenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.658 2.5.836.813c.373.363.56.545.494.7-.065.154-.33.154-.857.154H7.663c-3.31 0-5.995 2.611-5.995 5.833 0 1.24.397 2.389 1.075 3.333M6.343 17.501l-.836-.813c-.373-.363-.56-.545-.494-.699s.33-.154.858-.154h6.467c3.311 0 5.995-2.612 5.995-5.834a5.7 5.7 0 0 0-1.074-3.333"
  })));
};
export default SvgAiRegenerate;